<div class="flex flex-col" >

    <div class="flex px-6 py-4 w-full border-b border-solid border-[#53565B22]" >
        <p  class="text-[#1E1E20] text-base mb-0 font-semibold  "  >Automatic Naming </p>
    </div>
    <div class="px-6 py-4"  >
        <div class=" px-6 flex flex-row justify-between  border border-solid flex  h-[72px]  border-[#D3DCE8] rounded-[10px]" >
            <p class="  text-[#242731] text-sm mb-0 font-normal leading-[72px]">
                Enable Automatic Naming for this Template
            </p>
            <mat-slide-toggle
            class="mt-[26px]"
            [(ngModel)]="enable"
            (click)="onToggleClick($event)"
          >
          </mat-slide-toggle>
    
        </div>
     </div>
    <div class="border-t border-solid border-[#53565B22] flex justify-end px-6 py-3" >
        <button (click)="close()" style="margin-right: 12px;"  class="rounded border border-solid  border-[#53565B22]  w-[72px] bg-transparent h-8 text-[#1E1E20] text-xs mb-0 font-semibold" >
            Cancel
        </button>
        <button (click)="save()" class="rounded w-[72px] h-8 bg-[#25508E] text-[#ffffff] text-xs mb-0 font-semibold">
            Save 
        </button>
    </div>
</div>